import React, {useMemo} from 'react';
import {classes, style} from './doppe-page-footer-banner.st.css';
import {FlexLayout} from "@wix/devzai-common-client";
import {DoppeViewerAttributionLink, SourceType} from '../doppe-viewer-attribution-link/doppe-viewer-attribution-link';
import {BymoPageViewerMode, useBymoPageViewerContext} from "../bymo-page-viewer-context/bymo-page-viewer-context";
import {DoppeBiEmptyTargetUrl} from "../../client-server-common";
import {useDoppeViewerClientServices} from "../../client/doppe-user-app/doppe-viewer-client-services";
import {useBymoPageContextProps} from "../../doppe-sdk";
import {useDoppeViewerLocales} from "../../client/doppe-viewer-locales/doppe-viewer-locales";

export const DoppePageFooterBanner = React.memo(function DoppePageFooterBanner (props: DoppePageFooterBanner.Props) {
    const {
        bannerMessage,
        targetUrl = `https://www.hopp.co`,
        brandName = 'hopp',

        className,
        ...htmlAttributes
    } = props;

    const clientServices = useDoppeViewerClientServices();
    const pageViewerContext = useBymoPageViewerContext();
    const bymoPageContextProps = useBymoPageContextProps();
    const doppeViewerLocales = useDoppeViewerLocales();

    const sourceType = useMemo(()=>{
        if (pageViewerContext.mode === BymoPageViewerMode.Live) {
            if(pageViewerContext.pageType === 'action-page') {
                return SourceType.LandingPage;
            }
            else if(pageViewerContext.pageType === 'speed-dial') {
                return SourceType.BioPage;
            }
            else  {
                return SourceType.PreRoll;
            }
        }

        return SourceType.LandingPage;
    }, [pageViewerContext])

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className, FlexLayout.row.alignToCenter)}
        >
            <div
                className={style(classes.messageContainer, {})}
            >
                {`${doppeViewerLocales['createdWithHopp']} `}
            </div>
            <DoppeViewerAttributionLink
                className={style(classes.startNowButton, {})}
                targetUrl={targetUrl}
                sourceType={sourceType}
                onClick={() => {
                    if (pageViewerContext.mode === BymoPageViewerMode.Live) {
                        clientServices.viewerAnalyticsClient.logEvent('uouHypeBannerClicked', {
                            hypeUserId: pageViewerContext.doppeUserId,
                            linkId: pageViewerContext.linkId,
                            pageId: pageViewerContext.bymoPageId,
                            destinationUrl: bymoPageContextProps.targetUrl ?? DoppeBiEmptyTargetUrl,
                            pageType: pageViewerContext.pageType,
                        })
                    }
                }}
            >
                {`${doppeViewerLocales['tryForFree']}`}
            </DoppeViewerAttributionLink>
        </div>
    );
});

export namespace DoppePageFooterBanner {

    export interface Props extends React.HTMLAttributes<any> {
        bannerMessage: string;
        targetUrl?: string;
        brandName?: string;
    }
}
